import { resolveUpgradePlanPath } from '@/constants/upgrade-plan'

import type { EntitlementDeniedPayload } from './types'

export function isEntitlementDeniedPayload(
  value: unknown,
): value is EntitlementDeniedPayload {
  if (!value || typeof value !== 'object') return false
  const obj = value as Record<string, unknown>
  return obj.error === 'entitlement_denied' && typeof obj.feature_key === 'string'
}

export function parseEntitlementDeniedFromResponse(
  status: number,
  body: unknown,
): EntitlementDeniedPayload | null {
  if (status !== 403 || !isEntitlementDeniedPayload(body)) return null
  const orgSlug =
    typeof body.organisation_slug === 'string' ? body.organisation_slug : null
  return {
    error: 'entitlement_denied',
    feature_key: body.feature_key,
    organisation_slug: orgSlug ?? '',
    upgrade_path:
      (typeof body.upgrade_path === 'string' && body.upgrade_path) ||
      resolveUpgradePlanPath(orgSlug),
    reason: typeof body.reason === 'string' ? body.reason : undefined,
  }
}

export function parseEntitlementDeniedFromStreamEvent(
  data: Record<string, unknown>,
): EntitlementDeniedPayload | null {
  if (data.error === 'entitlement_denied' && typeof data.feature_key === 'string') {
    const orgSlug =
      typeof data.organisation_slug === 'string' ? data.organisation_slug : null
    return {
      error: 'entitlement_denied',
      feature_key: data.feature_key,
      organisation_slug: orgSlug ?? '',
      upgrade_path:
        (typeof data.upgrade_path === 'string' && data.upgrade_path) ||
        resolveUpgradePlanPath(orgSlug),
      reason: typeof data.reason === 'string' ? data.reason : undefined,
    }
  }
  return null
}
